module.exports = __webpack_public_path__ + "img/VideoPlay.png.9f621ab6.svg";